import { Empty, HandHeartLineIcon } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { EntityList } from 'features/channels/components';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useGivingsInfiniteQuery } from 'features/givings/queries';

type P = {
  getPathToGivingDetail: (id: string) => string;
  organizationId: string;
};

const OrganizationsGivingsList = ({ getPathToGivingDetail, organizationId }: P) => {
  const {
    data: allGivingsData,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingAll,
    isLoading: isLoadingAll,
  } = useGivingsInfiniteQuery({
    filter: { organizationId },
    pagination: { pageSize: 12 },
  });

  const allGivings = allGivingsData?.pages.flat().flatMap((givingsPaginated) => givingsPaginated.data);

  return (
    <EntityList
      empty={
        <Empty
          description={{ subtitle: 'There are no givings to display here', title: 'No givings' }}
          image={<HandHeartLineIcon />}
        />
      }
      entities={allGivings?.map((giving) => ({
        data: giving,
        type: 'Giving',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToGivingDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetchingAll}
      isLoading={isLoadingAll}
    />
  );
};

export default OrganizationsGivingsList;
